import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";

const customerDefaultColumns = [
  "CODE",
  "DISPLAY NAME",
  "LINKED TO XERO",
  "LEGAL NAME",
  "TYPE",
  "COMPANY ID",
  "EMAIL",
  "PHONE NO",
  "CURRENCY",
  "GST NO",
  "DEFAULT PAYMENT TERM",
  "DEFAULT SALE ACCOUNT",
  "CREDIT HOLD",
  "CREDIT LIMIT AMOUNT",
  "SUB TYPE",
  "TAGS",
  "SALES REP",
  "DEFAULT TAX RATE",
  "DEFAULT FACILITY",
  "STATUS",
  "CREATED BY",
  "CREATE DATE",
];

const customerTagDefaultColumns = [
  "NAME",
  "SHORT DESCRIPTION",
  "TAG STATUS",
  "CREATED BY",
  "CREATE DATE",
];

const customerSegmentDefaultColumns = [
  "CUSTOMER SEGMENT NAME",
  "COUNTRY",
  "REGION / STATE",
  "CITY",
  "POSTCODE",
  "STATUS",
  "CUSTOMER TYPE",
  "CUSTOMER SUB TYPE",
  "ACCOUNT STATUS",
  "PAYMENT TERMS",
  "TAGS",
];

const initialState = {
  customers: { count: 0, results: [] },
  customerSelection: [],
  customersParams: { limit: 10, offset: 0 },

  customerLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: customerDefaultColumns,
      allViews: {
        "Default View": customerDefaultColumns,
      },
      nameOfViews: [],
    },
  },
  customerTags: { count: 0, results: [] },
  customerTagsParams: { limit: 10, offset: 0 },
  customerTagLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: customerTagDefaultColumns,
      allViews: {
        "Default View": customerTagDefaultColumns,
      },
      nameOfViews: [],
    },
  },
  customerTagsSelection: [],
  customerSegments: { count: 0, results: [] },
  customerSegmentSelection: [],
  customerSegmentsParams: { limit: 10, offset: 0 },
  customerSegmentLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: customerSegmentDefaultColumns,
      allViews: {
        "Default View": customerSegmentDefaultColumns,
      },
      nameOfViews: [],
    },
  },
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    getCustomers: (state, action) => {
      state.customers = action.payload;
    },
    setCustomerSelection: (state, action) => {
      state.customerSelection = action.payload;
    },
    resetCustomers: state => {
      state.customers = initialState.customers;
    },
    setCustomersParams: (state, action) => {
      state.customersParams = action.payload;
    },
    setCustomerLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.customerLayout = {
        ...state.customerLayout,
        listView: {
          ...state.customerLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.customerLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    updateCustomersParams: (state, action) => {
      state.customersParams = { ...state.customersParams, ...action.payload };
    },
    resetCustomersParams: state => {
      state.customersParams = { limit: state.customersParams.limit, offset: 0 };
    },
    getCustomerTags: (state, action) => {
      state.customerTags = action.payload;
    },
    setCustomerTagLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.customerTagLayout = {
        ...state.customerTagLayout,
        listView: {
          ...state.customerTagLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.customerTagLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    updateCustomerTagsParams: (state, action) => {
      state.customerTagsParams = { ...state.customerTagsParams, ...action.payload };
    },
    resetCustomerTagsParams: state => {
      state.customerTagsParams = { limit: state.customerTagsParams.limit, offset: 0 };
    },
    setCustomerTagsSelection: (state, action) => {
      state.customerTagsSelection = action.payload;
    },
    setCustomerSegments: (state, action) => {
      state.customerSegments = action.payload;
    },
    setCustomerSegmentSelection: (state, action) => {
      state.customerSegmentSelection = action.payload;
    },
    setCustomerSegmentLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.customerSegmentLayout = {
        ...state.customerSegmentLayout,
        listView: {
          ...state.customerSegmentLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.customerSegmentLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    updateCustomerSegmentsParams: (state, action) => {
      state.customerSegmentsParams = { ...state.customerSegmentsParams, ...action.payload };
    },
    resetCustomerSegmentsParams: state => {
      state.customerSegmentsParams = { limit: state.customerSegmentsParams.limit, offset: 0 };
    },
  },
});

export const {
  getCustomers,
  setCustomerSelection,
  resetCustomers,
  setCustomersParams,
  setCustomerLayoutAllViews,
  updateCustomersParams,
  resetCustomersParams,
  getCustomerTags,
  setCustomerTagLayoutAllViews,
  updateCustomerTagsParams,
  resetCustomerTagsParams,
  setCustomerTagsSelection,
  setCustomerSegments,
  setCustomerSegmentSelection,
  setCustomerSegmentLayoutAllViews,
  updateCustomerSegmentsParams,
  resetCustomerSegmentsParams,
} = customerSlice.actions;

export default customerSlice.reducer;
